import { StepConnect } from "@features/StepsContent/components/StepConnect/StepConnect";
import { StepStart } from "@features/StepsContent/components/StepStart/StepStart";
import { stepsStore } from "@/widgets/StepsManager/store/stepsStore";
import { StepEmail } from "./components/StepEmail/StepEmail";
import { StepCode } from "./components/StepCode/StepCode";
import { STEPS_ENUM } from "@/widgets/StepsManager/store/types";
import LoginSelectPage from "@pages/authPage/LoginSelectPage";
import { appStore } from "@/app/store/appStore";
import { StepEmailConnect } from "@features/StepsContent/components/StepEmail/StepEmailConnect";
import { StepSignUpComplete } from "@features/StepsContent/components/StepSignUpComplete/StepSignUpComplete";

export const StepsContent = () => {
	const { activeStep } = stepsStore();

	switch (activeStep) {
		case STEPS_ENUM.EmailStep:
			return <StepEmail />;

		case STEPS_ENUM.EmailStepConnect:
			return <StepEmailConnect />;

		case STEPS_ENUM.CodeStep:
			return <StepCode />;

		case STEPS_ENUM.ConnectStep:
			return <StepConnect />;

		case STEPS_ENUM.StartStep:
			return <StepStart />;

		case STEPS_ENUM.LoginSelectStep:
			return <LoginSelectPage />;

		default: {
			return <StepSignUpComplete />;
		}
	}
};
